<div appTabs [ngpTabsetValue]="filters.detailsTab()" (ngpTabsetValueChange)="setTab($event)">
  <div appTabList class="details-tablist">
    <span
      appTabIndicator
      [class.details-tabindicator--notes]="filters.detailsTab() === 'notes'"
      [class.details-tabindicator--history]="filters.detailsTab() === 'history'"
    ></span>
    <button appTabButton ngpTabButtonValue="details">Geral</button>
    <button appTabButton ngpTabButtonValue="notes">Notas</button>
    <button appTabButton ngpTabButtonValue="history">Histórico</button>
  </div>

  <div appTabPanel ngpTabPanelValue="details">
    @if (channelSummary(); as ch) {
      <section class="details-section details-section--first">
        <h2>Canal</h2>
        <div appUiPanelCard class="channel-card">
          <app-channel-icon [channel]="ch.kind" variant="header" class="channel-card__icon" />
          <div class="channel-card__text">
            <span class="channel-card__name">
              {{ ch.name }}
              @if (!ch.active) { <span appBadge tone="neutral" size="xs">Desativado</span> }
            </span>
            @if (ch.number) { <span class="channel-card__number">{{ ch.number }}</span> }
          </div>
        </div>
      </section>
    }

    <section class="details-section">
      <h2>Operação</h2>
      <div class="details-stack">
        <div appUiPanelCard class="routing-row">
          <span>Responsável</span>
          <strong>{{ conversation()!.owner }}</strong>
        </div>
        <div appUiPanelCard class="routing-row">
          <span>Equipe</span>
          <strong>{{ conversation()!.team }}</strong>
        </div>
        <div appUiPanelCard class="routing-row">
          <span>SLA</span>
          <span class="sla-cell">
            @if (slaBadge(); as badge) {
              <strong appBadge size="xs" [tone]="slaBadgeTone(badge.tone)">{{ badge.label }}</strong>
              @if (badge.tone === 'paused') {
                <button
                  type="button"
                  appUiIconButton
                  variant="ghost"
                  size="xs"
                  title="Remover pausa"
                  aria-label="Remover pausa"
                  (click)="unsnooze()"
                >
                  <ng-icon name="heroXMark" size="13" aria-hidden="true" />
                </button>
              }
            } @else {
              <strong>{{ conversation()!.sla }}</strong>
            }
          </span>
        </div>
        <div appUiPanelCard class="routing-row">
          <span>Prioridade</span>
          <strong>{{ priorityLabel(conversation()!.priority) }}</strong>
        </div>
      </div>
    </section>

    <section class="details-section">
      <h2>Tags</h2>
      <app-labels-picker class="mt-2 block" [conversationId]="conversation()!.id" />
    </section>
  </div>

  <div appTabPanel ngpTabPanelValue="notes">
    <section class="details-section details-section--first">
      <div *appIfPermission="'conversations:base:notes:write'" class="note-composer">
        <textarea
          appTextarea
          surface="transparent"
          rows="3"
          placeholder="Nota interna (não enviada ao contato)"
          [value]="noteDraft()"
          (input)="setNoteDraft($any($event.target).value)"
        ></textarea>
        <div class="mt-2 flex justify-end">
          <button appButton variant="primary" size="sm" type="button" [disabled]="noteDraft().trim().length === 0" (click)="addNote()">
            Salvar nota
          </button>
        </div>
      </div>

      <ol class="mt-3 space-y-2">
        @for (note of store.selectedNotes(); track note.id) {
          <li class="note-item" [class.note-item--focused]="filters.focusedNoteId() === note.id">
            <div class="note-item__head">
              <span class="note-item__author">{{ note.author }}</span>
              <span class="flex items-center gap-2">
                <time class="note-item__time">{{ note.time }}</time>
                <button *appIfPermission="'conversations:base:notes:delete'" type="button" appUiIconButton variant="danger" size="xs" aria-label="Excluir nota" (click)="deleteNote(note.id)">
                  <ng-icon name="heroTrash" size="13" aria-hidden="true" />
                </button>
              </span>
            </div>
            <p class="note-item__body">{{ note.body }}</p>
          </li>
        } @empty {
          <li appUiEmptyText>Nenhuma nota interna ainda.</li>
        }
      </ol>
    </section>
  </div>

  <div appTabPanel ngpTabPanelValue="history">
    <app-history-tab [conversationId]="conversation()!.id" />
  </div>
</div>
